// dev环境配置文件
// export const API_ROOT = 'http://test.oa-web.innotechx.com/api';
// export const API_ROOT = 'http://test1.oa-api.com';
export const API_ROOT = 'https://oa.fancydigital.com.cn/api';




// WEBPACK FOOTER //
// ./src/config.dev.js